import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { Tilintarkastaja } from 'app/_jaettu-lemonator/model/tilintarkastaja'
import { TilintarkastajaUriService } from 'app/_jaettu-lemonator/service/tilintarkastaja-uri.service'
import { TilintarkastajaService } from 'app/_jaettu-lemonator/service/tilintarkastaja.service'
import { combineLatest, Observable, of } from 'rxjs'
import { switchMap, tap } from 'rxjs/operators'
import { TilintarkastajaAsiakasComponentDataResolve } from '../_resolvers/asiakas.resolve'
import { FirebaseLemonator } from '../service/firebase-lemonator.service'
import { KirjautunutTilintarkastajaService } from '../service/kirjautunut-tilintarkastaja.service'

@Injectable()
export class TilintarkastajaAsiakasGuard {
  constructor(
    private _router: Router,
    private _kirjautunutTilintarkastajaService: KirjautunutTilintarkastajaService,
    private _firebaseLemonator: FirebaseLemonator,
    private _tilintarkastajaService: TilintarkastajaService,
    private _tilintarkastajaUriService: TilintarkastajaUriService,
    private _tilintarkastajaAsiakasComponentDataResolve: TilintarkastajaAsiakasComponentDataResolve,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([this._tilintarkastajaAsiakasComponentDataResolve.resolve(route), this._kirjautunutTilintarkastajaService.tilintarkastajaObservable]).pipe(
      switchMap(([asiakas, tilintarkastajaTiedot]) => {
        if (!tilintarkastajaTiedot) {
          return of(false)
        }

        return this._firebaseLemonator
          .firestoreDoc<Tilintarkastaja>(this._tilintarkastajaUriService.annaTilintarkastajaUri(tilintarkastajaTiedot.tilintarkastajaAvain))
          .get()
          .then(tilintarkastaja => {
            if (!tilintarkastaja) {
              return false
            }
            return this._tilintarkastajaService.onkoOikeusVoimassa(tilintarkastaja, asiakas.avain)
          })
      }),
      tap(sallittu => {
        if (!sallittu) {
          this._router.navigate(['/tilintarkastajat/kirjaudu'])
        }
      }),
    )
  }
}
